const s = "modalLinks__items_oRMsB", o = "modalLinks__modal_CcB9R", _ = {
  modalLinks__items: s,
  modalLinks__modal: o
};
export {
  _ as default,
  s as modalLinks__items,
  o as modalLinks__modal
};
//# sourceMappingURL=modalLinks.module.scss.js.map
